import {
  OtcContractLayerDto,
} from "@/lib/api/otc";

export function generateAmendmentTitleForLayer(layer: OtcContractLayerDto): string {
  switch (layer.source_type) {
    case "initial":
      return "Original Contract";
    case "split_result":
      return "Split Result";
    case "migration_backfill":
      return "Historical Contract";
    case "amendment": {
      switch (layer.amendment_type) {
        case "split":
          return "Split";
        case "contract_type_change":
          return "Contract Type Change";
        case "roll":
          return layer.roll_direction === "down" ? "Roll Down" : "Roll Up";
        case "exit":
          return "Exit";
        default:
          return "Amendment";
      }
    }
    default:
      return "Layer";
  }
}
